import React from "react";
import ProductImage from "../ProductImage";
import "./ProductAdmin.scss";

type Props = {
  product: any;
  onEdit: (product: any) => void;
  onDelete: (id: string) => void;
};

const ProductAdmin: React.FC<Props> = ({ product, onEdit, onDelete }) => {
  const isLowStock = product?.quantity <= 3;
  const isOnSale = product?.sold > 0;

  return (
    <div className="product-admin-card">
      {/* IMAGE */}
      <div className="product-admin-card__image">
        <ProductImage productId={product?._id} />

        {isOnSale && (
          <span className="badge sale">-{product.sold}%</span>
        )}
      </div>

      {/* ACTIONS */}
      <div className="product-admin-card__actions">
        <button
          className="icon-btn danger"
          title="Delete product"
          onClick={() => onDelete(product._id)}
        >
          <i className="bx bx-trash" />
        </button>

        <button
          className="icon-btn"
          title="Edit product"
          onClick={() => onEdit(product)}
        >
          <i className="bx bx-edit" />
        </button>
      </div>

      {/* INFO */}
      <div className="product-admin-card__info">
        <div className="top-row">
          <h3 className="name" title={product?.name}>
            {product?.name}
          </h3>
          <span className="price">{product?.price} DT</span>
        </div>

        <div className="meta-row">
          <span className={`stock ${isLowStock ? "low" : ""}`}>
            {product?.quantity} in stock
          </span>
          {product?.weight && (
            <span className="storage">{product.weight} Go</span>
          )}
        </div>

        <p className="desc">{product?.description}</p>
      </div>
    </div>
  );
};

export default ProductAdmin;
